/**
 *  TODO: Replace with either buyer specific level lower data
 *  or remove entirly
 */
// import type { IQuestionnaireSetPageData } from '@unionco/alaris-app-types'
import { phaseStepsFixture } from '@fixtures/phase'

export const buyerQuestionnaireFixture = {
  // contentType: 'questionnaireSet',
  currentStep: 1,
  pageName: 'Phase Name',
  pageRoute: 'phase-name',
  sections: phaseStepsFixture
} // as IQuestionnaireSetPageData
